import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface KlingV26I2vParams {
  /**
   * 输入图片,支持URL或base64格式,URL会自动转换为base64
   */
  image: string;
  /**
   * 视频生成提示词,可选,最多2500字符
   * @length 0 - 2500
   */
  prompt?: string;
  /**
   * 生成模式,V2.6仅支持pro模式
   * @values pro
   */
  mode: 'pro';
  /**
   * 音频开关,可选值: on/off
   * @values on | off
   */
  sound?: 'on' | 'off';
  /**
   * 视频时长(秒)
   * @values 5 | 10
   */
  duration?: '5' | '10';
  /**
   * 外部任务ID
   */
  external_task_id?: string;
  /**
   * 静态遮罩
   */
  static_mask?: string;
  /**
   * 动态遮罩列表
   */
  dynamic_masks?: Array<{
  }>;
}

export interface KlingV26I2vResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * kling_v2_6_i2v
 *
 * <p>Kling AI V2.6 图片生成视频接口</p>
 * <p>API Documentation: <a href="https://docs.qingque.cn/d/home/eZQB6Bbl5WgW8eIVN--duPVl1?identityId=2Cn18n4EIHT">https://docs.qingque.cn/d/home/eZQB6Bbl5WgW8eIVN--duPVl1?identityId=2Cn18n4EIHT</a></p>
 * 
 *
 * @example
 * ```typescript
 * import { initSeacloud, klingV26I2v } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await klingV26I2v({
 *   // 参数见 KlingV26I2vParams 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 KlingV26I2vParams 接口定义
 * @returns 生成的资源列表
 */
export async function klingV26I2v(
  params: KlingV26I2vParams,
): Promise<KlingV26I2vResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 5000,
    maxAttempts: 120,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'kling_v2_6_i2v',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: KlingV26I2vResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
